import { PropsWithChildren } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

// Create a default query client that works in both Vite and Next.js environments
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      retry: 1,
    },
  },
});

interface ReactQueryClientProviderProps extends PropsWithChildren {
  showDevtools?: boolean;
}

export const ReactQueryClientProvider = ({
  children,
  showDevtools,
}: ReactQueryClientProviderProps) => {
  return (
    <QueryClientProvider client={queryClient}>
      {children}
      {showDevtools && <ReactQueryDevtools initialIsOpen={false} />}
    </QueryClientProvider>
  );
};
